import script from "./DomainOwnerInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DomainOwnerInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./DomainOwnerInfoModal.vue?vue&type=style&index=0&id=e11c96a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e11c96a2"]])

export default __exports__